import { ColumnDef } from "@tanstack/react-table"

import { CommodityRate } from "@/types/meter"

import { DataTableColumnHeader } from "../../data-table"
import { ConnectionStatusOperation } from "../operations/connection-status-operation"
import { CommodityRateOperation } from "../operations/commodity-rates-operation"

export const commodityRate: ColumnDef<CommodityRate>[] = [
  {
    accessorKey: "rate_type",
    header: ({ column }) => (
      <DataTableColumnHeader
        className="flex justify-center"
        column={column}
        title="Connection Type"
      />
    ),
    cell: ({ row }: { row: { original: CommodityRate } }) => {
      const value = row.original.rate_type
      return <div className="truncate text-center">{value}</div>
    },
  },
  {
    accessorKey: "volume_tier",
    header: ({ column }) => (
      <DataTableColumnHeader
        className="flex justify-center"
        column={column}
        title="Volume Tier"
      />
    ),
    cell: ({ row }: { row: { original: CommodityRate } }) => {
      const value = row.original.volume_tier
      return <div className="truncate text-center">{value}</div>
    },
  },
  {
    accessorKey: "range",
    header: ({ column }) => (
      <DataTableColumnHeader
        className="flex justify-center"
        column={column}
        title="Range (m³)"
      />
    ),
    cell: ({ row }: { row: { original: CommodityRate } }) => {
      const { min_volume, max_volume } = row.original
      const value = max_volume
        ? `${min_volume} - ${max_volume}`
        : `${min_volume}+`
      return <div className="truncate text-center">{value}</div>
    },
  },
  {
    accessorKey: "charge_per_cubic_meter",
    header: ({ column }) => (
      <DataTableColumnHeader
        className="flex justify-center"
        column={column}
        title="Price / m³"
      />
    ),
    cell: ({ row }: { row: { original: CommodityRate } }) => {
      const value = row.original.charge_per_cubic_meter
      return <div className="truncate text-center">{`₱${value}`}</div>
    },
  },
  {
    accessorKey: "unlimited_tier",
    header: ({ column }) => (
      <DataTableColumnHeader
        className="flex justify-center"
        column={column}
        title="Unlimited"
      />
    ),
    cell: ({ row }: { row: { original: CommodityRate } }) => {
      const value = row.original.unlimited_tier ? "Yes" : "No"
      return <div className="truncate text-center">{value}</div>
    },
  },
  {
    accessorKey: "actions",
    header: () => <div className="text-center">Actions</div>,
    cell: ({ row }: { row: { original: CommodityRate } }) => (
      <div className="px-4 py-2 text-center md:py-0">
        <CommodityRateOperation data={row.original} />
      </div>
    ),
  },
]
